// import MapDataProvider from "../../../pages/Views/LandInfraDevelopment/GISView/MapRelated/MapData/MapDataProvider";
// import { Route } from "react-router-dom";
// //prettier-ignore
// import { ViewMap, ViewMapByCategoryPage, ViewInfrastructureMap, ViewCadastreMap, ViewPlanningMap } from "../../../pages/Views/LandInfraDevelopment/GISView/MapRelated/Views";
// import ExportDataPage from "../../../pages/Views/LandInfraDevelopment/GISView/MapRelated/ExportDataPage";
// import PrintMap from "../../../pages/Views/LandInfraDevelopment/GISView/MapRelated/PrintMap/PrintMap";

// import BuildingPermitList from "../../../pages/Views/LandInfraDevelopment/Head/BuildingPermitList";
// import OccupancyPermitList from "../../../pages/Views/LandInfraDevelopment/Head/OccupancyPermitList";

// import LandInfraReports from "../../../pages/Views/LandInfraDevelopment/Head/Report/LandInfraReports";
// import LandInfraDevelopmentDashboard from "../../../pages/Views/LandInfraDevelopment/Head/LandInfraDevelopmentDashboard";
// import LandUseProportionDetailCard from "../../../pages/Views/LandInfraDevelopment/Head/DashboardDetail/LandUseProportionDetailCard";
// // import RequestPlaceParcelOnHold from "../../../pages/Views/LandInfraDevelopment/Head/RequestPlaceParcelOnHoldjsx";


// export default function LandAndInfraDevelopmentHeadRoutes() {
//   return (
//     <>
//       <Route path="/" element={<LandInfraDevelopmentDashboard />} />
//       <Route path="/viewMap" element={<ViewMap />} />
//       <Route path="/viewMapByCategory" element={<ViewMapByCategoryPage />} />
//       <Route path="/infrastructureMap" element={<ViewInfrastructureMap />} />
//       <Route path="/viewCadastreMap" element={<ViewCadastreMap />} />
//       <Route path="/printMap" element={<PrintMap />} />
//       <Route path="/exportMap" element={<MapDataProvider><ExportDataPage /></MapDataProvider>} />
//       <Route path="/viewPlanningMap" element={<ViewPlanningMap />} />
//       <Route path="/landInfraReports" element={<LandInfraReports />} />
//       <Route path="/listBPermit" element={<BuildingPermitList />} />
//       <Route path="/listOPermit" element={<OccupancyPermitList />} />
//       <Route path="/landUseProportionDetail" element={<LandUseProportionDetailCard />} />
//       {/* <Route path="/requestplaceOnHold" element={<RequestplaceParcelOnHold />} /> */}

      
//     </>
//   );
// }
import MapDataProvider from "../../../pages/Views/LandInfraDevelopment/GISView/MapRelated/MapData/MapDataProvider";
import { Route } from "react-router-dom";
//prettier-ignore
import { 
	ViewMap, 
	ViewMapByCategoryPage, 
	ViewInfrastructureMap, 
	ViewCadastreMap, 
	ViewPlanningMap 
} from "../../../pages/Views/LandInfraDevelopment/GISView/MapRelated/Views";
import DesignReportSelector from "../../../pages/Views/LandInfraDevelopment/DesignAndConstructionView/Reports/DesignReportSelector";

import ExportDataPage from "../../../pages/Views/LandInfraDevelopment/GISView/MapRelated/ExportDataPage";
import PrintMap from "../../../pages/Views/LandInfraDevelopment/GISView/MapRelated/PrintMap/PrintMap";
import LandUseParkReport from "../../../pages/Views/LandInfraDevelopment/Head/LandUseParkReport";
import LeasedLandPark from "../../../pages/Views/LandInfraDevelopment/Head/LeasedLandPark"
// Import components - ensure these files exist with exact names
import BuildingPermitList from "../../../pages/Views/LandInfraDevelopment/Head/BuildingPermitList";
import OccupancyPermitList from "../../../pages/Views/LandInfraDevelopment/Head/OccupancyPermitList";
import LandInfraReports from "../../../pages/Views/LandInfraDevelopment/Head/Report/LandInfraReports";
import LandInfraDevelopmentDashboard from "../../../pages/Views/LandInfraDevelopment/Head/LandInfraDevelopmentDashboard";
import LandUseProportionDetailCard from "../../../pages/Views/LandInfraDevelopment/Head/DashboardDetail/LandUseProportionDetailCard";
//import RequestPlaceParcelOnHold from "../../../pages/Views/LandInfraDevelopment/Head/RequestPlaceParcelOnHold";
import RequestPlaceParcelOnHold from "../../../pages/Views/LandInfraDevelopment/Head/RequestPlaceParcelOnHold";
import ApproveImported from "../../../pages/Views/LandInfraDevelopment/MasterPlanandLandBankView/Forms/ApproveImportedSpatialInfo2";
import ViewUnapprovedSplitAndMerge2 from "../../../pages/Views/LandInfraDevelopment/GISView/MapRelated/Views/ViewUnapprovedSplitAndMerge";
import ViewUnapprovePlan2 from "../../../pages/Views/LandInfraDevelopment/GISView/MapRelated/Views/ViewUnapprovePlan2";
import  RatioReport from "../../../pages/Views/LandInfraDevelopment/GISView/Reports/RatioReport"
export default function LandAndInfraDevelopmentHeadRoutes() {
	return (
		<>
			<Route path="/" element={<LandInfraDevelopmentDashboard />} />
			<Route path="/viewMap" element={<ViewMap />} />
			<Route path="/landleasedpark" element={<LeasedLandPark />} />
			<Route path="/landparkuse" element={<LandUseParkReport />} />
			<Route path="/viewMapByCategory" element={<ViewMapByCategoryPage />} />
			<Route path="/infrastructureMap" element={<ViewInfrastructureMap />} />
			<Route path="/viewCadastreMap" element={<ViewCadastreMap />} />
			<Route path="/printMap" element={<PrintMap />} />
			<Route 
				path="/exportMap" 
				element={
					<MapDataProvider>
						<ExportDataPage />
					</MapDataProvider>
				} 
			/>
			<Route path="/viewPlanningMap" element={<ViewPlanningMap />} />
			<Route path="/landInfraReports" element={<RatioReport />} />
			<Route path="/designandconstruction" element={<DesignReportSelector />} />
			<Route path="/listBPermit" element={<BuildingPermitList />} />
			<Route path="/listOPermit" element={<OccupancyPermitList />} />
			<Route path="/landUseProportionDetail" element={<LandUseProportionDetailCard />} />
		   <Route path="/requestPlaceOnHold" element={<RequestPlaceParcelOnHold />} />
		   <Route path="/ApproveMapEdit" element={<ApproveImported />} />
		   <Route path="/Approveinvestorplan" element={<ViewUnapprovePlan2/>} />
		 
		   <Route path="/viewUnapprovedSplitAndMergeMap" element={<ViewUnapprovedSplitAndMerge2 />} />
		   
		   

		</>
	);
}